<template>
<div >
  <div class="content">
    <div class="row header">
      <div class="col">
          <h1 class="no-margin-bottom">{{ data.title }}</h1>
          <h3>{{ data.subtitle }}</h3>
          <div v-html="data.body"></div>
      </div>
    </div>
  </div>

  <div class="row menu">
    <div class="ui-rounded-btns" id="policy-controll">
      <div class="ui-icon">
        <v-lottie-player
            class="lottie-video-player"
            autoplay
            loop
            :animationData="require('@/assets/videos/1-icon-complexity.json')"
            height="300"
            width="300"
            style="background: transparent; position: absolute; top: 10px; right: 10px; bottom: 10px; left: 10px;"
        />
        <img src="@/assets/svg/chapter-1/1-complexity.svg">
      </div>
      <div class="ui-icon">
        <v-lottie-player
            class="lottie-video-player"
            autoplay
            loop
            :animationData="require('@/assets/videos/1-icon-increased-scale.json')"
            height="300"
            width="300"
            style="background: transparent; position: absolute; top: 10px; right: 10px; bottom: 10px; left: 10px;"
        />
        <img src="@/assets/svg/chapter-1/2-increased.svg">
      </div>
      <div class="ui-icon">
        <v-lottie-player
            class="lottie-video-player"
            autoplay
            loop
            :animationData="require('@/assets/videos/1-icon-flexibility.json')"
            height="300"
            width="300"
            style="background: transparent; position: absolute; top: 10px; right: 10px; bottom: 10px; left: 10px;"
        />
        <img src="@/assets/svg/chapter-1/3-flexibility.svg">
      </div>
    </div>      
  </div>
</div>

</template>

<script>

export default {
  props: ['data']
}
</script>

<style lang="scss" scoped>
  @import '@/scss/_variables.scss';
  .row{
    &.content-block{
      position: absolute;
      left: 0;
      right: 0;
      top: 250px;
      bottom: 80px;
      background-color: $color-nokia-neutral-lighter;
    }
    &.menu{
      height: 440px;
      background-color: $color-nokia-neutral-lighter;
    }
  }
</style>